import { useDispatch, useSelector } from "react-redux";
import { TextLinkProps, UserState } from "../../types-interfaces/interfaces";
import TextLink from "../text/TextLink";
import { RootState } from "../../redux/store";
import { setBreadCrumbs } from "../../redux/slices/main/mainSlice";
import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { TextLinkGroupAStyle, TextLinkGroupStyle } from "../styles/MenuStyle";

interface MenuLinkProps extends React.HTMLAttributes<Element>{
  textLinks?: Array<TextLinkProps> | undefined
  text?: string | undefined  
}

function MenuLink(props:MenuLinkProps) {
  const [showing, setShowing] = useState(false);
  const [menuShowing, setMenuShowing] = useState("none");
  const dispatch = useDispatch();
  const user = useSelector<RootState, UserState>((state) => state.userState);

  useEffect(() => {
    var isMenuShowing = (props.textLinks?.filter(tl => (tl.profiles?.filter(p => user.profiles.indexOf(p) > -1).length ?? 0 )> 0).length ?? 0) > 0;
    setMenuShowing(isMenuShowing ? "flex" : "none");
  }, [props.textLinks, user.profiles])

  return(
    <div
      style={{
        display: menuShowing,
        flexDirection:"column",
      }}
      onPointerLeave={()=> setShowing(false)}
    >
      <TextLink
        text={props.text}
        icon={<ChevronDown style={{          
          color: "#fff",
          width:"16px"
        }}/>}
        onClick={() => setShowing(!showing)}        
      />
      { showing &&
      <div
        onMouseLeave={() => setShowing(false)}
        onMouseEnter={()=> setShowing(true)}
        style={{
          display:"block",
          position:"absolute",
          marginTop:"30px",
        }}
      >
        <div
          style={{
            background:"#fff",            
            height:"10px",
            clipPath: "polygon(45px 0, 35px 100%, 55px 100%)",
            borderBottom:"solid 2 px #fff",
            zIndex:"1"
          }}
        >
          &nbsp;
        </div>
        <div style={TextLinkGroupStyle}>
        { props.textLinks && 
          props.textLinks.map((tl, index) => 
            ( user && user.profiles && user.profiles.length > 0 &&
              tl.profiles && tl.profiles.length > 0 &&
              tl.profiles.filter(p => user.profiles.indexOf(p) > -1).length > 0) &&
            <TextLink
              key={index}
              text={tl.text}
              url={tl.url}              
              onClick={() => {dispatch(setBreadCrumbs([{name:tl.text, url:tl.url}]))}}
              onMouseEnter={()=> setShowing(true)}
              onMouseLeave={()=> setShowing(false)}
              linkstyle={TextLinkGroupAStyle}
            />
          )
        }
        </div>
      </div>
      }
    </div>
  );

}

export default MenuLink;